import { render, staticRenderFns } from "./btns.vue?vue&type=template&id=1d481a78"
import script from "./btns.vue?vue&type=script&lang=js"
export * from "./btns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports